import {blue_arrow, green_arrow} from '../../utils/images';
import Colors from '../../assets/Color/Colors';

export const REWARDS_EARN_TOKENS = {
  'marketing-making-rewards': {
    borderColors: Colors.green,
    colors: ['rgba(0, 166, 69, 0.1)', 'rgba(49, 200, 111, 0.1)'],
    redirect: 'market',
  },
  'deposit-and-earn': {
    borderColors: Colors.purple,
    colors: ['rgba(170, 0, 255, 0.1)', 'rgba(168, 94, 205, 0.1)'],
    redirect: 'deposit',
  },
  'opinion-polls': {
    borderColors: Colors.tradexBlue,
    colors: ['rgba(10, 87, 255, 0.1)', 'rgba(10, 87, 255, 0.05)'],
    redirect: 'opinionPoll',
  },
  'create-event': {
    borderColors: Colors.noColor,
    colors: ['rgba(202, 44, 146, 0.1)', 'rgba(202, 44, 146, 0.05)'],
    redirect: 'createEvent',
  },
};

export const REWARDS_TRADE_TOKENS = {
  'tokens-event': {
    colors: ['#265CFF', '#7592EA'],
    img: blue_arrow,
    styles: {
      marginRight: 8,
      flex: 1,
      height: 150,
      marginTop: 20,
    },
    redirect: 'tokenEvent',
  },
  contests: {
    colors: ['#31C86F', '#31C86F'],
    img: green_arrow,
    styles: {
      marginLeft: 8,
      flex: 1,
      height: 150,
      marginTop: 20,
    },
    redirect: 'contest',
  },
};
